import { Component } from '@angular/core';
import { PasButtonRoundColor, PasButtonRoundComponent } from '@porsche-aftersales/frontend-toolbox';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-download-cell-renderer',
  templateUrl: './download-cell-renderer.component.html',
  imports: [PasButtonRoundComponent],
})
export class DownloadCellRenderer implements ICellRendererAngularComp {
  private params: any;

  public agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  public refresh(params: any): boolean {
    this.params = params;
    return false;
  }

  public onDownload($event: any): void {
    if (this.params.onDownload instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data,
      };
      this.params.onDownload(params);
    }
  }

  public isDownloadable(): boolean {
    return true;
  }

  public readonly pasButtonRoundColor = PasButtonRoundColor;
}
